import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import { BrowserRouter } from 'react-router-dom';
import CustomThemeProvider from './Theme/CustomThemeProvider';
import GenericModalContextProvider from './components/context/GenericModalContextProvider';
import GenericSnackBarContextProvider from './components/context/GenericSnakBarContextProvider';
import { ErrorBoundary } from 'react-error-boundary';
import BuzzFallback, {
  errorHandler,
} from './components/BuzzFallback/BuzzFallback';
import BreadCrumbContextProvider from './components/context/BreadCrumbContextProvider';
import GenericApprovalModalProvider from './components/context/GenericApprovalModalProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModuleScopeProvider from './components/context/ModuleScopeProvider';
// import { MuiPickersUtilsProvider } from '@material-ui/pickers';
// import MomentUtils from '@date-io/moment';

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={BuzzFallback} onError={errorHandler}>
      <BrowserRouter>
        <Provider store={store}>
          <CustomThemeProvider>
            <GenericSnackBarContextProvider>
              <GenericModalContextProvider>
                <ModuleScopeProvider>
                  <GenericApprovalModalProvider>
                    <BreadCrumbContextProvider>
                      <App />
                      <ToastContainer />
                      {/* <MuiPickersUtilsProvider utils={MomentUtils}>
                  </MuiPickersUtilsProvider> */}
                    </BreadCrumbContextProvider>
                  </GenericApprovalModalProvider>
                </ModuleScopeProvider>
              </GenericModalContextProvider>
            </GenericSnackBarContextProvider>
          </CustomThemeProvider>
        </Provider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
